import React from 'react';
import {
  HStack,
  Avatar,
  AvatarGroup,
  Input,
  Icon,
  Button,
  Box
} from '@chakra-ui/react';
import { FiSearch, FiFilter } from 'react-icons/fi';

const SearchAndFilters = ({ users, searchValue, onSearchChange, onFilterOpen, onReset }) => {
  return (
    <HStack spacing={4} align="center">
      {/* Avatar Group - Board members */}
      <AvatarGroup size="sm" max={5} spacing="-8px">
        {(users || []).map((user) => (
          <Avatar
            key={user.id}
            src={user.avatar}
            name={user.name || `User ${user.id}`}
            w="32px"
            h="32px"
            border="2px solid white"
          />
        ))}
      </AvatarGroup>

      {/* Filter Input with Search Icon */}
      <Box position="relative">
        <Input
          placeholder="Filter"
          size="sm"
          width="180px"
          pl={8}
          bg="#FAFBFC"
          border="1px"
          borderColor="#DFE1E6"
          borderRadius="4px"
          fontSize="14px"
          _focus={{
            borderColor: "#0065FF",
            boxShadow: "0 0 0 1px #0065FF",
          }}
          value={searchValue}
          onChange={onSearchChange}
        />
        <Icon
          as={FiSearch}
          position="absolute"
          left={3}
          top="50%"
          transform="translateY(-50%)"
          color="#6B778C"
          boxSize="14px"
        />
      </Box>

      {/* Filter Button */}
      <Button
        size="sm"
        colorScheme="blue"
        variant="outline"
        leftIcon={<FiFilter />}
        onClick={onFilterOpen}
      >
        Filter
      </Button>

      {/* Reset Button */}
      <Button
        size="sm"
        variant="outline"
        colorScheme="red"
        onClick={onReset}
      >
        Clear
      </Button>
    </HStack>
  );
};

export default SearchAndFilters;